import { render, staticRenderFns } from "./WizardTreeArrowNavigation.vue?vue&type=template&id=0a60f3ec&scoped=true&"
import script from "./WizardTreeArrowNavigation.vue?vue&type=script&lang=js&"
export * from "./WizardTreeArrowNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a60f3ec",
  null
  
)

export default component.exports